<script setup lang="ts">
const props = defineProps({
  hs: {
    type: String,
    required: true
  }
})
</script>

<template>
  <div
    :id="props.hs"
    :data-hs-overlay-keyboard="false"
    class="hs-overlay fixed left-0 top-0 z-[60] hidden h-screen w-full overflow-y-auto overflow-x-hidden bg-white text-new-secondary backdrop-blur-md backdrop-brightness-200"
  >
    <div
      class="mb-14 h-max w-full bg-background-primary opacity-90 transition-all ease-out hs-overlay-open:duration-500 lg:mb-0"
    >
      <div class="h-full min-h-[100vh] w-full">
        <slot />
      </div>
    </div>
  </div>
</template>
